import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { switchMap, concatMap, tap, debounceTime } from 'rxjs/operators';
import { orderService, ShopContext } from '../shop/shop/shop-context';
import removeClass from '@opten/dom/remove-class';
import addClass from '@opten/dom/add-class';
import { distinctUntilUserChanged } from '../utilities/observable.helper';
import { fromEvent } from 'rxjs';

declare var Swiper: any;

@Component({ className: 'js-product-slider', observe: true })
export class ProductSlider {
	private instance: any;

	@ComponentRef(ShopContext) shopContext: ShopContext;
	altView: HTMLElement;
	pagination: HTMLElement;

	constructor(private element: HTMLElement) {
		const wrapper = this.element.querySelector('.js-product-slider__wrapper');
		this.pagination = this.element.querySelector<HTMLElement>('.js-product-slider__pagination');
		const itemsWrapper = this.element.querySelector('.js-product-slider__products') as HTMLElement;

		const large = this.element.hasAttribute('data-large');

		this.altView = this.element.parentElement.querySelector('.js-product-slider__alt') as HTMLElement;

		if (wrapper && this.pagination) {
			this.instance = new Swiper(wrapper, {
				spaceBetween: 5,
				slidesPerView: 2,
				autoHeight: false,
				breakpoints: large ? this.getConfigForLarge() : this.getConfigForSmall()
			});

			const targetNode = this.element.parentElement;
			const observer = new MutationObserver(() => {
				if (targetNode.style.display !== 'none') {
					this.getLatestOrderedProducts(itemsWrapper);
				}
			});

			observer.observe(targetNode, { attributes: true, childList: true });

			fromEvent(window, 'resize')
				.pipe(debounceTime(250))
				.subscribe(() => this.instance.update());
		}
	}

	private getLatestOrderedProducts(itemsWrapper: HTMLElement) {
		this.shopContext.onAuthenticationChanged
			.pipe(
				distinctUntilUserChanged(),
				concatMap(user => orderService.getLastOrderedProducts(user.customerId))
			)
			.subscribe(products => {
				if (products) {
					addClass(this.altView, 'd-none');
					removeClass(this.element, 'd-none');
					itemsWrapper.innerHTML = products;
					this.instance.update();
				} else {
					removeClass(this.altView, 'd-none');
					addClass(this.element, 'd-none');
				}
			});
	}

	private getConfigForSmall() {
		return {
			320: {
				slidesPerView: 1,
				pagination: {
					el: this.pagination,
					type: 'fraction',
					clickable: true
				},
				navigation: {
					nextEl: this.element.querySelector('.js-product-slider-next'),
					prevEl: this.element.querySelector('.js-product-slider-prev')
				}
			},
			576: {
				slidesPerView: 2,
				pagination: {
					el: this.pagination,
					type: 'fraction',
					clickable: true
				},
				navigation: {
					nextEl: this.element.querySelector('.js-product-slider-next'),
					prevEl: this.element.querySelector('.js-product-slider-prev')
				}
			},
			768: {
				pagination: {
					el: this.pagination,
					type: 'bullets',
					clickable: true
				}
			},
			1350: {
				slidesPerView: 3,
				pagination: {
					el: this.pagination,
					type: 'bullets',
					clickable: true
				}
			}
		};
	}

	private getConfigForLarge() {
		return {
			320: {
				slidesPerView: 1,
				pagination: {
					el: this.pagination,
					type: 'fraction',
					clickable: true
				},
				navigation: {
					nextEl: this.element.querySelector('.js-product-slider-next'),
					prevEl: this.element.querySelector('.js-product-slider-prev')
				}
			},
			576: {
				slidesPerView: 2,
				pagination: {
					el: this.pagination,
					type: 'fraction',
					clickable: true
				},
				navigation: {
					nextEl: this.element.querySelector('.js-product-slider-next'),
					prevEl: this.element.querySelector('.js-product-slider-prev')
				}
			},
			768: {
				pagination: {
					el: this.pagination,
					type: 'bullets',
					clickable: true
				}
			},
			992: {
				slidesPerView: 3,
				pagination: {
					el: this.pagination,
					type: 'bullets',
					clickable: true
				}
			},
			1350: {
				slidesPerView: 4,
				pagination: {
					el: this.pagination,
					type: 'bullets',
					clickable: true
				}
			}
		};
	}
}
